<template>
  <div />
</template>

<script>
import router from '@/router'
import { setPendingLoginReload, setStoredAuthRedirectToast } from '@/helpers/authSession'

export default {
  computed: {
    me() {
      return this.$store.getters['auth/getUser']
    },
  },
  mounted() {
    if (this.me.id) {
      setStoredAuthRedirectToast('auth.logout-success')
      setPendingLoginReload()
      this.$store.dispatch('auth/logout')
        .finally(() => {
          router.push({ name: 'login' })
        })
    } else {
      router.push({ name: 'login' })
    }
  },
}
</script>
